import { Controller } from "@hotwired/stimulus"

// Toggles between "subdomain on the platform base domain" and "own custom
// domain" in the org form, with a live preview of the resulting host.
export default class extends Controller {
  static targets = ["mode", "subdomainWrap", "customWrap", "subInput", "preview"]
  static values = { base: String }

  connect() { this.update() }

  update() {
    const mode = this.currentMode()
    this.subdomainWrapTarget.classList.toggle("hidden", mode !== "subdomain")
    this.customWrapTarget.classList.toggle("hidden", mode !== "custom")
    this.renderPreview()
  }

  currentMode() {
    const checked = this.modeTargets.find((m) => m.checked)
    return checked ? checked.value : "subdomain"
  }

  renderPreview() {
    if (!this.hasPreviewTarget) return
    if (this.currentMode() === "subdomain") {
      const sub = (this.hasSubInputTarget ? this.subInputTarget.value : "").trim().toLowerCase()
      this.previewTarget.textContent = `https://${sub || "subdominio"}.${this.baseValue}`
    } else {
      this.previewTarget.textContent = ""
    }
  }
}
